import { DocumentContainer } from 'components/Shared';
import React from 'react';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
`;
const Title = styled.div `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const ImpactClaimDocumentsList = ({ attachments, goToDocument, activeDocumentIndex, }) => {
    if (!(attachments === null || attachments === void 0 ? void 0 : attachments.length))
        return null;
    return (React.createElement(Container, { "data-cy": "proof-documents-container" }, attachments.map(({ node: document }, index) => (React.createElement(DocumentContainer, { key: document.id, document: document, active: activeDocumentIndex === index, onDocumentClick: goToDocument
            ? (e) => {
                e.preventDefault();
                e.stopPropagation();
                goToDocument(index);
            }
            : undefined },
        React.createElement(Title, null, document.title))))));
};
export default ImpactClaimDocumentsList;
